import React, { useEffect, useRef, useState } from 'react';
import { configs } from '../../../app/app-configs';
import FileDropzone from '../../../components/file-dropzone';

interface ProfileImageDropzoneProps {
    file?: string;
    onFileChange: (file: File | null) => void;
}

const ProfileImageDropzone: React.FC<ProfileImageDropzoneProps> = (props) => {
    const [file, setFile] = useState<File | null>(null);
    const objectUrlRef = useRef<string | null>(null);
    const defaultPreview = `${configs.FILE_UPLOAD_S3_URL}/default-profile.jpg`;
    const [preview, setPreview] = useState<string>(props.file ? `${configs.FILE_UPLOAD_S3_URL}/${props.file}` : defaultPreview);

    useEffect(() => {
        if (!file) {
            setPreview(props.file ? `${configs.FILE_UPLOAD_S3_URL}/${props.file}` : defaultPreview);
        }
    }, [props.file, file, defaultPreview]);

    useEffect(() => {
        return () => {
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
            }
        };
    }, []);

    const onProfileImageChange = (nextFile: File | null) => {
        setFile(nextFile);
        props.onFileChange(nextFile);

        if (objectUrlRef.current) {
            URL.revokeObjectURL(objectUrlRef.current);
            objectUrlRef.current = null;
        }

        if (nextFile) {
            const nextPreview = URL.createObjectURL(nextFile);
            objectUrlRef.current = nextPreview;
            setPreview(nextPreview);
            return;
        }

        setPreview(defaultPreview);
    };

    return (
        <FileDropzone
            file={props.file}
            onFileChange={onProfileImageChange}
            accept={{
                'image/jpeg': ['.jpg', '.jpeg'],
                'image/png': ['.png'],
            }}
            selectButtonLabel="Select Profile Picture"
            removeButtonLabel="Remove Profile Picture"
            containerStyle={{ gap: '20px', alignItems: 'center', justifyItems: 'center' }}
            actionContainerStyle={{ marginTop: '8px' }}
            selectButtonProps={{ sx: { mx: 2, my: 1 } }}
            removeButtonProps={{ sx: { mx: 2 } }}
            renderContent={() => (
                <img
                    src={preview}
                    alt=""
                    style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: '50%', margin: 'auto' }}
                />
            )}
        />
    );
};

export default ProfileImageDropzone;